import React from 'react';
import {Table} from 'antd';
import CameraButtonUpdate from './CameraButtonUpdate';
import CameraButtonCopy from './CameraButtonCopy';
import CameraButtonDelete from './CameraButtonDelete';
import {roleStationManagement} from '../constants/defaultValues'

class CameraTable extends React.Component {
  render() {
    const {role, cameras, categories, fetching, onCreate, onUpdate, onDelete} = this.props
    const columns = [
      {
        title: 'Tên',
        dataIndex: 'Name',
        key: 'name'
      }, {
        title: 'Địa chỉ IP',
        dataIndex: 'IP',
        key: 'ip'
      }, {
        title: 'Loại',
        dataIndex: 'Category.Name',
        key: 'category'
      }, {
        title: '...',
        key: 'action',
        render: (text, camera) => (
          roleStationManagement(role)
          ? <span>
            <CameraButtonUpdate camera={camera} categories={categories} onUpdate={onUpdate}/>
            <span className="ant-divider"/>
            <CameraButtonCopy camera={camera} categories={categories} onCopy={onCreate}/>
            <span className="ant-divider"/>
            <CameraButtonDelete camera={camera} onDelete={onDelete}/>
          </span>
          : null)
      }
    ];
    return <Table columns={columns} dataSource={cameras} rowKey={cam => cam.ID} loading={fetching}/>
  }
}
export default CameraTable



// WEBPACK FOOTER //
// ./src/components/CameraTable.js